export default __webpack_public_path__ + "static/104-d2051c0e677067bce828eda4b1587e70.jpg";